import React  from "react";
import { useStyles } from "./BillingStyle";
import CircleIcon from '../../assets/icons/circleIcon.png';
import FileIcon from '../../assets/icons/fileIcon.png';
import NoteIcon from '../../assets/icons/noteIcon.png';
import WarningIcon from '../../assets/icons/warningIcon.png';
import AppBar from '@material-ui/core/AppBar';
import Overview from './overview/Overview';
import UseBilling from './UseBilling';
import Credits from './credits/Credits';
import Invoice from './invoice/Invoice';
import Information from './information/Information';
export default function Billing() {
  const [value, setValue] = React.useState(0);
  const styles = useStyles();
  const [{ invoices, credits, invoicesHeadings, creditsHeadings, BillingCreditHeading, BillingCredits,size }] = UseBilling();

  return (
    <div
      style={{ width: size.width < 960 ? "100%" : size.width - 330 }}
    >
      <div className={styles.amountAndNameContainersRow}>
        <div className={styles.nameContainer}>
          <p className={styles.projectBillingText}>Project Billing</p>
          <div className={styles.nameAndIconRow}>
            <div className={styles.iconContainer}>
              <img width={14} height={16} src={CircleIcon} alt="circle" />
            </div>
            <p className={styles.billerName}>omarfarukuiux.50 </p>
          </div>
        </div>
        <div className={styles.priceContainer}>
          <div className={styles.iconAndAmountRow}>
            <div className={styles.amountBillContainer}>
              <p className={styles.detailsText}>Current accumulated monthly bill</p>
              <p className={styles.amount}>$ 44.68 USD</p>
              <p className={styles.detailsText}>No credit card assigned</p>
            </div>
            <div className={styles.fileIconContainer}>
              <img width={32} height={40} src={FileIcon} alt="icon" />
            </div>
          </div>
        </div>
      </div>
      {
        value === 0 ?
          <div className={styles.noteContainer}>
            <div className={styles.infoIconContainer}>
              <img width={36} height={36} src={NoteIcon} alt="icon" />
            </div>
            <div className={styles.noteTextContainer}>
              <p className={styles.noteText}>NOTE</p>
              <p className={styles.importantNote}>The Project is managed by account billing group.</p>
            </div>
          </div>
          :
          value === 1 ?
            <div className={styles.warningContainer}>
              <div className={styles.warningIconContainer}>
                <img width={36} height={36} src={WarningIcon} alt="icon" />
              </div>
              <div className={styles.noteTextContainer}>
                <p className={styles.warningText}>WARNING</p>
                <p className={styles.importantWarning}>There is no payment method set up for this project.</p>
              </div>
            </div>
            :
            value === 2 ?
              <div className={styles.warningContainer}>
                <div className={styles.warningIconContainer}>
                  <img width={36} height={36} src={WarningIcon} alt="icon" />
                </div>
                <div className={styles.noteTextContainer}>
                  <p className={styles.warningText}>WARNING</p>
                  <p className={styles.importantWarning}>There is no payment method set up for this project.</p>
                </div>
              </div>
              :
              value == 3 ?
                <div className={styles.warningContainer}>
                  <div className={styles.warningIconContainer}>
                    <img width={36} height={36} src={WarningIcon} alt="icon" />
                  </div>
                  <div className={styles.noteTextContainer}>
                    <p className={styles.warningText}>WARNING</p>
                    <p className={styles.importantWarning}>There is no payment method set up for this project.</p>
                  </div>
                </div>
                :
                null
      }
      <div className={styles.root}>
        <AppBar elevation={0} position="static" color="default" className={styles.appBar}>
          <div className={'tabsRow'}>
            <div onClick={() => setValue(0)} className={value === 0 ? styles.selected : styles.notSelected}><p className={value !== 0 ? styles.tabHead : styles.activeTab}>Overview</p></div>
            <div onClick={() => setValue(1)} className={value === 1 ? styles.selected : styles.notSelected}><p className={value !== 1 ? styles.tabHead : styles.activeTab}>Credits</p></div>
            <div onClick={() => setValue(2)} className={value === 2 ? styles.selected : styles.notSelected}><p className={value !== 2 ? styles.tabHead : styles.activeTab}>Invoices</p></div>
            <div onClick={() => setValue(3)} className={value === 3 ? styles.selected : styles.notSelected}><p className={value !== 3 ? styles.tabHead : styles.activeTab}>Billing information</p></div>
          </div>
        </AppBar>
        {
          value === 0 ?
            <div className={styles.tabsBodyContainer}>
              <div className={styles.tableTitleRow}>
                <p className={styles.tableTitle}>Invoices</p>
                <p className={styles.titleForAll}>All Invoices</p>
              </div>
              <Overview data={invoices} headings={invoicesHeadings} />
              <div className={styles.tableTitleRow}>
                <p className={styles.tableTitle}>Credits</p>
                <p className={styles.titleForAll}>All Credits</p>
              </div>
              <Overview data={credits} headings={creditsHeadings} />
            </div> :
            value === 1 ?
              <>
                <Credits data={BillingCredits} headings={BillingCreditHeading} />
              </>
              :
              value == 2 ?
                <div className={styles.tabsBodyContainer}>
                  <Invoice headings={invoicesHeadings} data={invoices} />
                </div>
                :
                value == 3 ?
                  <div className={styles.tabsBodyContainer}>
                    <Information />
                  </div>
                  :
                  null
        }
      </div>
    </div>
  )
}
